<ng-container *transloco="let t">
  <pxw-action-sheet
    [hidden]="false"
    [label]="t('global.actions')"
    background="blue"
    appareance="solid"
    [cancelText]="t('global.cancel')"
    [width]="250"
  >
    <ng-template #buttonTemplate let-toggle="toggleActionSheet">
      {{ taxVoucherType() }}:
      <a class="ui-help-link" (click)="$event.stopImmediatePropagation(); toggle()">
        #{{ taxVoucherRef() }}
      </a>
    </ng-template>
    <pxw-button
      style="opacity: 0.8"
      size="md"
      appareance="link"
      color="blue"
      display="inline"
      (click)="$event.stopImmediatePropagation()"
    >
      <pxw-icon icon="eye" />
      {{ t('Ver comprobante') }}
    </pxw-button>
    <pxw-button
      style="opacity: 0.8"
      size="md"
      appareance="link"
      color="blue"
      display="inline"
      (click)="$event.stopImmediatePropagation()"
    >
      <pxw-icon icon="arrow-down" />
      {{ t('Descargar comprobante') }}
    </pxw-button>
    <pxw-button
      style="opacity: 0.8"
      size="md"
      appareance="link"
      color="blue"
      display="inline"
      (click)="$event.stopImmediatePropagation()"
    >
      <pxw-icon icon="print" />
      {{ t('Imprimir comprobante') }}
    </pxw-button>
    @if (taxVoucher().operation === 'bill') {
      <hr class="ui-separator ui-separator--sm" />
      <pxw-button
        style="opacity: 0.8"
        size="md"
        appareance="link"
        color="pink"
        display="inline"
        (click)="$event.stopImmediatePropagation()"
      >
        <pxw-icon icon="ban" />
        {{ t('Nota de crédito') }}
      </pxw-button>
    }
  </pxw-action-sheet>
</ng-container>
